// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"435":"96cf9b57","558":"ba7a4937","698":"7b2ada89","772":"f5bccc5a"}[chunkId] + ".chunk.css";
};